import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';
import { RepService } from '../../services/rep.service';

@Component({
  selector: 'app-admin-vehicle-type',
  templateUrl: './admin-vehicle-type.component.html'
})
export class AdminVehicleTypeComponent implements OnInit {

  vehicleType: any = null;
  isSaving = false;
  isEdit = false;
  disabled = false;
  id?: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public shared: SharedService,
    private repService: RepService
  ) { }

  async ngOnInit(): Promise<void> {
    this.disabled = !this.shared.rights?.r_edit;

    const idParam = this.route.snapshot.paramMap.get('id_vehicle_type');
    this.id = idParam && idParam !== 'new' ? parseInt(idParam, 10) : undefined;
    this.isEdit = !!this.id;

    if (this.isEdit) {
      try {
        const data = await this.repService.getVehicleType(this.id!);
        if (data) this.vehicleType = data;
      } catch (error) {
        this.shared.reportError(error, 'Error loading vehicle type');
        this.shared.error('Nepodařilo se načíst typ vozidla');
      }
    } else {
      this.vehicleType = {
        id_vehicle_type: null,
        name: '',
        avg_charging_power_kw: null,
        sort_order: 0,
        is_active: true
      };
    }
  }

  async onSubmit(): Promise<void> {
    this.isSaving = true;
    try {
      const payload: any = { ...this.vehicleType };
      if (this.id) payload.id_vehicle_type = this.id;
      const result = await this.repService.saveVehicleType(payload);
      if (result) {
        this.shared.success(this.isEdit ? 'Typ vozidla byl upraven' : 'Typ vozidla byl vytvořen');
        this.router.navigate(['/admin/settings']);
      }
    } catch (error) {
      this.shared.reportError(error, 'Error saving vehicle type');
      this.shared.error('Nepodařilo se uložit typ vozidla');
    } finally {
      this.isSaving = false;
    }
  }

  async deleteType(): Promise<void> {
    if (!this.id) return;
    this.shared.modalYesNo('Opravdu chcete smazat tento typ vozidla?', null, async () => {
      try {
        await this.repService.deleteVehicleType(this.id!);
        this.shared.success('Typ vozidla byl smazán');
        this.router.navigate(['/admin/settings']);
      } catch (error) {
        this.shared.reportError(error, 'Error deleting vehicle type');
        this.shared.error('Nepodařilo se smazat typ vozidla');
      }
    });
  }

  goBack(): void {
    this.location.back();
  }
}
